import { useCallback } from 'react';

import qs from 'qs';

import { useNewsAndGuidesDetailsPageData } from 'src/app/pages/newsAndGuides/details/pageContext';
import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

import type { Channel } from './types';

export function useGetShareUrl(): ShareActionsOptions<Channel>['getUrl'] {
	const {
		data: {
			countryCode,
			details: { slug },
		},
	} = useNewsAndGuidesDetailsPageData();

	return useCallback(
		(medium) => {
			const trackParams = qs.stringify(
				{
					utm_source: 'news_show',
					utm_campaign: 'share_news',
					utm_medium: medium,
				},
				{ encodeValuesOnly: true },
			);
			return `/l/${countryCode}/${slug}?${trackParams}`;
		},
		[countryCode, slug],
	);
}
